import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { DataService } from './data.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private data: DataService, private route: Router, private location: Location) { 
    
    this.router.events.subscribe((e)=>{
      if (e instanceof NavigationEnd){
        console.log("Navigation completed");
        console.log("Back buttons tate is:" + this.data.showBackButton);
        this.showBackButton = this.data.showBackButton;
        this.backPath = this.data.backPath;
        this.title = this.router.routerState.root.firstChild.snapshot.data.title;
      } else if (e instanceof NavigationStart){
        this.showBackButton = false;
        this.backPath = "";
      }

      
    })
  }
  public loggedIn : string
  public title: string

  //Set this before navigating to ensure that back button is displayed and can go back to given path
  public showBackButton = false;
  public backPath = "";


  onBackClicked():boolean{
    //this.data.RaiseEvent("back");
    //this.router.navigate([this.data.backPath],{skipLocationChange: false});
    this.location.back();
    return false;
  }

  ngOnInit(): void {
    
    this.loggedIn = this.data.isLoggedIn ? "logo-right" : "logo-left";
    this.data.events.subscribe((val)=>{
      switch(val){
        case "login":{
          this.data.isLoggedIn = true;
          this.data.backPath = "";
          this.backPath = "";
          this.loggedIn = this.data.isLoggedIn ? "logo-right" : "logo-left";
        }
        case "logout":{
          this.router.navigate(['']);
        }
      }
    })
  }


}
